import {Injectable} from '@angular/core';
import {FilterParams, RepositoryService} from "../../../helpers/crud/repository.service";

import {WancomHttpService} from "../../../services/wancom-http/wancom-http.service";
import {WaitingService} from "../../layout/waiting/waiting.service";
import { Spot } from '../../spots/model/spot.model';
import { SpotTemplate } from '../model/spotTemplate.model';

@Injectable({
	providedIn: 'root'
})
export class SpotTemplateService extends RepositoryService<any> {
	constructor(http: WancomHttpService, waiting$: WaitingService) {
		super(http, waiting$, 'spotTemplates');
	}

	getTemplateProperties(spotId: number, faceId: number) {	
		if(faceId){
			return this.http.get<Spot>(`${this.url}/getTemplateProperties/${spotId}/${faceId}`);
	
		}
		else{
			return this.http.get<Spot>(`${this.url}/getTemplateProperties/${spotId}`);
		}
	}

}

@Injectable()
export class SpotTemplateFilterParams extends FilterParams {
	name?: string;
	forFaceId?: number;
	noProduct?: boolean;
	spotDuration?: number;
	diffusionId?: number;
	spotCategoryIds?: number[];
}
